import React from 'react'

import type { IFullScreenLoaderProps } from './FullScreenLoader.types'
import * as S from './FullScreenLoader.styles'

import { AnimatedOptimoIcon } from '@/components/common/AnimatedOptimoIcon'

export const FullScreenLoader: React.FC<IFullScreenLoaderProps> = ({ text, noBackground = false }) => {
    return (
        <S.Container $noBackground={noBackground}>
            {!noBackground && <S.BackgroundPattern />}
            <S.ContentWrapper>
                <S.LoaderContainer>
                    <AnimatedOptimoIcon size={120} />
                </S.LoaderContainer>
                {text && <S.LoadingText>{text}</S.LoadingText>}
            </S.ContentWrapper>
        </S.Container>
    )
}
